import { render, staticRenderFns } from "./CustomersCorporate.vue?vue&type=template&id=7785b654"
import script from "./CustomersCorporate.vue?vue&type=script&lang=js"
export * from "./CustomersCorporate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports